import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Damage, DamageAnalysis, Roi } from '../../model/damage.model';
import { ParametersService } from '../../service/parameters.service';
import { RoiService } from '../../service/roi.service';
import { VehicleDamagePipe } from '../../pipes/vehicle-damage.pipe';
import { ThumbnailService } from '../../service/thumbnail.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-thumbnail-damage',
  templateUrl: './thumbnail-damage.component.html',
  styleUrls: ['./thumbnail-damage.component.less']
})
export class ThumbnailDamageComponent implements OnInit, OnDestroy {
  @Input() damage: DamageAnalysis;
  downloadUrl: string;
  spinner: boolean = false;


  constructor(private readonly _parametersService: ParametersService,
    readonly _roiService: RoiService,
    private readonly _thumbnailService: ThumbnailService) {
  }

  downloadImage() {
    this.spinner = true;
    this._thumbnailService.downloadImage(this.damage).then(() => {
      this.spinner = false
    })
  }

  ngOnInit() {
  }

  ngOnDestroy() {
  }

}



// WEBPACK FOOTER //
// ./src/app/element/thumbnail-damage/thumbnail-damage.component.ts